/**
 * lbf-gift-toast.js v1.2.0 (2026-09-26: live's design kept as THE gift notification; silent on /cart)
 * Site-wide, read-only notification for CartBot/EGO-injected free gifts.
 * This module never adds, removes, or changes a cart line.
 */
(function () {
  'use strict';
  var lbnT = window.lbnT || function (k, f, v) { return v ? String(f).replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, x) { return Object.prototype.hasOwnProperty.call(v, x) ? String(v[x]) : m; }) : f; };

  if (window.LBFGiftToast && window.LBFGiftToast.version) return;

  var VERSION = '1.0.0';
  var STORAGE_KEY = 'lbf-gift-toast-state-v1';
  var CART_MUTATION_RE = /\/cart\/(?:add|change)(?:\.js)?(?:[?#]|$)/i;
  var originalFetch = window.fetch;
  var originalXhrOpen = window.XMLHttpRequest && window.XMLHttpRequest.prototype.open;
  var originalXhrSend = window.XMLHttpRequest && window.XMLHttpRequest.prototype.send;
  var analyticsLayer = [];
  var snapshot = {};
  var initialized = false;
  var checking = false;
  var checkAgain = false;
  var queue = [];
  var playing = false;
  var toastTimer = null;
  var gapTimer = null;
  var scheduledTimers = {};
  var activeNotice = null;
  var domGuard = null;
  var guardTimers = [];

  try {
    window.dataLayer = window.dataLayer || [];
    analyticsLayer = window.dataLayer;
  } catch (e) {
    /* Keep a harmless local queue if another script blocks the global. */
  }

  function cartEndpoint() {
    var cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    return cartUrl.replace(/\/$/, '') + '.js';
  }

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function isCartMutation(input) {
    try {
      var url = new URL(requestUrl(input), window.location.origin);
      return CART_MUTATION_RE.test(url.pathname + url.search);
    } catch (e) {
      return CART_MUTATION_RE.test(requestUrl(input));
    }
  }

  function lineTitle(line) {
    return String(line.product_title || line.title || 'Free gift')
      .replace(/^\[Gift\]\s*/i, '')
      .replace(/\s+-\s+1\s+pkt\s*$/i, '')
      .trim();
  }

  function lineImage(line) {
    if (typeof line.image === 'string') return line.image;
    if (line.featured_image && typeof line.featured_image.url === 'string') return line.featured_image.url;
    return '';
  }

  function isGiftLine(line) {
    var title = String(line.product_title || line.title || '');
    return Number(line.final_price) === 0 && /^\[Gift\]/i.test(title);
  }

  function giftKey(line) {
    return String(line.key || line.variant_id || line.id || lineTitle(line));
  }

  function giftSnapshot(cart) {
    var gifts = {};
    (cart.items || []).forEach(function (line) {
      if (!isGiftLine(line)) return;
      var key = giftKey(line);
      gifts[key] = {
        key: key,
        title: lineTitle(line),
        image: lineImage(line),
        quantity: Math.max(1, Number(line.quantity) || 1),
        variant_id: line.variant_id || line.id || null,
      };
    });
    return gifts;
  }

  function saveSnapshot(gifts) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(gifts));
    } catch (e) {
      /* Storage can be unavailable in privacy modes; in-memory dedupe still works. */
    }
  }

  function restoreSnapshot() {
    try {
      var stored = sessionStorage.getItem(STORAGE_KEY);
      if (!stored) return false;
      var parsed = JSON.parse(stored);
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return false;
      snapshot = parsed;
      initialized = true;
      return true;
    } catch (e) {
      return false;
    }
  }

  function track(eventName, gift, cart) {
    try {
      if (!window.dataLayer) window.dataLayer = analyticsLayer;
      analyticsLayer.push({
        event: eventName,
        gift_title: gift.title,
        gift_quantity: gift.quantity,
        gift_variant_id: gift.variant_id,
        cart_total: Number(cart.total_price) || 0,
        cart_value: Number(cart.total_price) || 0,
        currency: cart.currency || null,
      });
    } catch (e) {
      /* Tracking must never affect the storefront. */
    }
  }

  function injectStyles() {
    if (document.getElementById('lbf-gift-toast-css')) return;
    var style = document.createElement('style');
    style.id = 'lbf-gift-toast-css';
    style.textContent =
      '.lbf-gift-toast{position:fixed;left:50%;bottom:max(20px,env(safe-area-inset-bottom));z-index:2147483000;display:flex;align-items:center;gap:10px;width:86%;max-width:430px;padding:10px 14px 10px 10px;box-sizing:border-box;background:#fff;border:1.5px solid #dba069;border-radius:16px;box-shadow:0 10px 28px rgba(0,0,0,.22);font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Arial,sans-serif;color:#2b2320;opacity:0;visibility:hidden;transform:translateX(-50%) translateY(8px);transition:opacity .16s cubic-bezier(.2,0,0,1),transform .16s cubic-bezier(.2,0,0,1),visibility 0s linear .16s;pointer-events:none}' +
      '.lbf-gift-toast.is-visible{opacity:1;visibility:visible;transform:translateX(-50%) translateY(0);transition-delay:0s;transition-duration:.2s}' +
      '.lbf-gift-toast.is-removed{border-color:#b5122b}' +
      '.lbf-gift-toast__image{width:46px;height:46px;border-radius:10px;object-fit:cover;background:#eee3d3;flex:0 0 46px}' +
      '.lbf-gift-toast__image[hidden]{display:none}' +
      '.lbf-gift-toast__copy{min-width:0;flex:1}' +
      '.lbf-gift-toast__title{font-size:12.5px;font-weight:800;line-height:1.3;color:#2b2320}' +
      '.lbf-gift-toast__pill{display:inline-block;margin-right:5px;padding:1px 7px;border-radius:10px;background:#1f6b45;color:#fff;font-size:9px;font-weight:800;line-height:1.45;vertical-align:1px;white-space:nowrap}' +
      '.lbf-gift-toast.is-removed .lbf-gift-toast__pill{background:#b5122b}' +
      '.lbf-gift-toast__sub{margin-top:2px;font-size:11.5px;line-height:1.35;color:#6b5f56}' +
      '@media(min-width:750px){.lbf-gift-toast{width:430px}}' +
      '@media(prefers-reduced-motion:reduce){.lbf-gift-toast{transition:none;transform:translateX(-50%)}}';
    document.head.appendChild(style);
  }

  function toastElement() {
    var toast = document.getElementById('lbf-gift-toast');
    if (toast) return toast;

    injectStyles();
    toast = document.createElement('div');
    toast.id = 'lbf-gift-toast';
    toast.className = 'lbf-gift-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('aria-atomic', 'true');

    var image = document.createElement('img');
    image.className = 'lbf-gift-toast__image';
    image.alt = '';

    var copy = document.createElement('div');
    copy.className = 'lbf-gift-toast__copy';
    var title = document.createElement('div');
    title.className = 'lbf-gift-toast__title';
    var pill = document.createElement('span');
    pill.className = 'lbf-gift-toast__pill';
    var name = document.createElement('span');
    name.className = 'lbf-gift-toast__name';
    var sub = document.createElement('div');
    sub.className = 'lbf-gift-toast__sub';

    title.appendChild(pill);
    title.appendChild(name);
    copy.appendChild(title);
    copy.appendChild(sub);
    toast.appendChild(image);
    toast.appendChild(copy);
    document.body.appendChild(toast);
    return toast;
  }

  function renderToast(item, recovery) {
    /* Carl 2026-09-26: on the cart page the gift simply appears as a line while the page refreshes - a toast on top confuses */
    if (/\/cart\/?$/.test(location.pathname)) { playing = false; activeNotice = null; return; }
    activeNotice = item;
    var toast = toastElement();
    var image = toast.querySelector('.lbf-gift-toast__image');
    var pill = toast.querySelector('.lbf-gift-toast__pill');
    var name = toast.querySelector('.lbf-gift-toast__name');
    var sub = toast.querySelector('.lbf-gift-toast__sub');
    var quantity = item.quantity || 1;

    toast.classList.toggle('is-removed', item.type === 'removed');
    image.hidden = !item.image;
    if (item.image) image.src = item.image;

    if (item.type === 'removed') {
      pill.textContent = lbnT('cart.gift_toast_removed_pill', 'GIFT REMOVED');
      name.textContent = item.title;
      sub.textContent = lbnT('cart.gift_toast_removed_sub', 'add more qualifying items to keep your free gift');
    } else if (item.type === 'summary') {
      pill.textContent = lbnT('cart.gift_toast_free_qty', 'FREE ×{{ n }}', { n: quantity });
      name.textContent = lbnT('cart.gift_toast_summary_name', '🎁 {{ n }} free gifts', { n: quantity });
      sub.textContent = lbnT('cart.gift_toast_added_sub', 'added to your cart');
    } else {
      pill.textContent = quantity > 1 ? lbnT('cart.gift_toast_free_qty', 'FREE ×{{ n }}', { n: quantity }) : lbnT('cart.gift_toast_free', 'FREE');
      name.textContent = item.title;
      sub.textContent = quantity > 1 ? lbnT('cart.gift_toast_packs_added', '{{ n }} free packs added to your cart 🎁', { n: quantity }) : lbnT('cart.gift_toast_added_sub_emoji', 'added to your cart 🎁');
    }

    /* Carl 2026-09-26: sit ABOVE the floating cart bar / cart footer, never on top of it */
    try {
      var lift = 0;
      Array.prototype.forEach.call(document.querySelectorAll('#lbf-collection-bar, .lbf-cj-footer'), function (bar) {
        var r = bar.getBoundingClientRect();
        if (r.height && r.bottom >= window.innerHeight - 2 && getComputedStyle(bar).visibility !== 'hidden') lift = Math.max(lift, window.innerHeight - r.top);
      });
      toast.style.bottom = lift ? Math.round(lift + 10) + 'px' : '';
    } catch (e) {}
    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });
    if (!recovery) {
      guardTimers.forEach(clearTimeout);
      guardTimers = [100, 400, 900, 1600, 2400].map(function (delay) {
        return setTimeout(function () {
          if (playing && activeNotice && !document.getElementById('lbf-gift-toast')) renderToast(activeNotice, true);
        }, delay);
      });
    }
    playing = true;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      clearTimeout(gapTimer);
      gapTimer = setTimeout(playNext, 350);
    }, 3000);
  }

  function playNext() {
    var next = queue.shift();
    if (!next) {
      playing = false;
      activeNotice = null;
      return;
    }
    renderToast(next);
  }

  function enqueue(items) {
    if (!items.length) return;
    queue = queue.concat(items);
    if (!playing) playNext();
  }

  function processDiff(next, cart) {
    var added = [];
    var removed = [];

    Object.keys(next).forEach(function (key) {
      var previous = snapshot[key];
      if (!previous) {
        added.push(next[key]);
      } else if (next[key].quantity > previous.quantity) {
        added.push(Object.assign({}, next[key], { quantity: next[key].quantity - previous.quantity }));
      } else if (next[key].quantity < previous.quantity) {
        removed.push(Object.assign({}, previous, { quantity: previous.quantity - next[key].quantity }));
      }
    });
    Object.keys(snapshot).forEach(function (key) {
      if (!next[key]) removed.push(snapshot[key]);
    });


    added.forEach(function (gift) {
      track('lbf_gift_added', gift, cart);
    });
    removed.forEach(function (gift) {
      track('lbf_gift_removed', gift, cart);
    });

    var notices = [];
    if (added.length >= 3) {
      notices.push({
        type: 'summary',
        quantity: added.length,
        image: added[0].image,
      });
    } else {
      added.forEach(function (gift) {
        notices.push({
          type: 'added',
          title: gift.title,
          image: gift.image,
          quantity: gift.quantity,
        });
      });
    }
    removed.forEach(function (gift) {
      notices.push({
        type: 'removed',
        title: gift.title,
        image: gift.image,
        quantity: gift.quantity,
      });
    });
    enqueue(notices);
  }

  function readCart() {
    return originalFetch.call(window, cartEndpoint(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed: ' + response.status);
      return response.json();
    });
  }

  function refresh(options) {
    options = options || {};
    if (checking) {
      checkAgain = true;
      return Promise.resolve(null);
    }
    checking = true;

    return readCart()
      .then(function (cart) {
        var next = giftSnapshot(cart);
        if (initialized && !options.silent) processDiff(next, cart);
        snapshot = next;
        initialized = true;
        saveSnapshot(next);
        return cart;
      })
      .catch(function (error) {
        return null;
      })
      .then(function (cart) {
        checking = false;
        if (checkAgain) {
          checkAgain = false;
          refresh();
        }
        return cart;
      });
  }

  function scheduleChecks() {
    [0, 800, 2000].forEach(function (delay) {
      clearTimeout(scheduledTimers[delay]);
      scheduledTimers[delay] = setTimeout(function () {
        delete scheduledTimers[delay];
        refresh();
      }, delay);
    });
  }

  function installFetchObserver() {
    if (typeof originalFetch !== 'function') return;
    window.fetch = function () {
      var args = arguments;
      var result = originalFetch.apply(this, args);
      if (isCartMutation(args[0])) {
        result.then(function (response) {
          if (response && response.ok) scheduleChecks();
        }).catch(function () {});
      }
      return result;
    };
  }

  function installXhrObserver() {
    if (!originalXhrOpen || !originalXhrSend) return;
    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.__lbfGiftCartMutation = isCartMutation(url);
      return originalXhrOpen.apply(this, arguments);
    };
    window.XMLHttpRequest.prototype.send = function () {
      if (this.__lbfGiftCartMutation) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 400) scheduleChecks();
        });
      }
      return originalXhrSend.apply(this, arguments);
    };
  }

  function installEventObservers() {
    document.addEventListener('cart:updated', scheduleChecks);
    document.addEventListener('cartUpdate', scheduleChecks);
    window.addEventListener('cart:updated', scheduleChecks);
    window.addEventListener('cartUpdate', scheduleChecks);

    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleChecks);
      }
    } catch (e) {
      /* Custom events and network observers remain active. */
    }
  }

  function installDomGuard() {
    if (typeof MutationObserver !== 'function' || domGuard) return;
    domGuard = new MutationObserver(function () {
      if (!playing || !activeNotice || document.getElementById('lbf-gift-toast') || !document.body) return;
      requestAnimationFrame(function () {
        if (playing && activeNotice && !document.getElementById('lbf-gift-toast')) renderToast(activeNotice, true);
      });
    });
    domGuard.observe(document.documentElement, { childList: true, subtree: true });
  }

  restoreSnapshot();
  installFetchObserver();
  installXhrObserver();
  installEventObservers();
  installDomGuard();
  refresh({ silent: !initialized });

  window.LBFGiftToast = {
    version: VERSION,
    refresh: refresh,
  };
})();
